import { Injectable } from '@angular/core';

import { Http, Response} from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Utilisateur } from '../model/utilisateur.model';
import { ConfigService } from '../shared/config.service';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/filter';
import 'rxjs/add/observable/timer';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/switch';
import { Router , ActivatedRoute } from '@angular/router';

@Injectable()
export class AuthenticationService {
clear
  _baseUrl: string ='';
  currentUser: Utilisateur;

  private authState:    AuthState;
  private authManager:  BehaviorSubject<AuthState>;
  public  authChange$:  Observable<AuthState>;

  constructor(private http: Http,
              private router: Router,
              private configService: ConfigService) {

                this._baseUrl = configService.getApiURI();
                this.authManager = new BehaviorSubject(AuthState.LOGGED_OUT);
                this.authChange$ = this.authManager.asObservable();
                this.authChange$
                .filter((authState: AuthState) => authState === AuthState.LOGGED_IN)
                .map( (authState: AuthState) => Observable.timer(SESSION_TIMEOUT))
                .do( () =>
                     console.log('Logged In. Session Timeout counting down from now'))
                .switch()
                .subscribe( () => {
                  // console.log('Timer ended : Logging out')

                    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
                    //if (this.currentUser!=null) {
                    //  this.deconnect(this.currentUser.utilisateurId)
                    //  .subscribe(
                    //    data => {

                    //    });
                    //}

                    this.logout();
                    this.router.navigate(['/authentication/login']);


              });



  }

  login(user: Utilisateur) : Observable<Utilisateur> {

    //console.log(JSON.stringify(user));
    return this.http.post(this._baseUrl + 'user/login', user)
        .map((response: Response) => {
            // login successful if there's a jwt token in the response
            let utilisateur = new Utilisateur();
            utilisateur = response.json();
            if (utilisateur) {
               // console.log(utilisateur);
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                //this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

                sessionStorage.setItem('parklife', JSON.stringify(utilisateur));
                this.setAuthState(AuthState.LOGGED_IN);
                this.router.navigate(['/reservation/cours']);
            }

            return utilisateur;
        });
  }

  logout()  {
    // remove user from local storage to log user out
    this.setAuthState(AuthState.LOGGED_OUT);

    sessionStorage.removeItem('parklife');


  }

  private setAuthState(newAuthState:AuthState):void {
    // console.log('AuthService: setAuthState: ',
        //AuthState[newAuthState.toString()]);
    if (newAuthState != this.authState) {
      this.authState = newAuthState;
      this.emitAuthState();
    }
  }

  emitAuthState():void {
    this.authManager.next(this.authState);
  }

}

export enum AuthState {
  LOGGED_IN,
  LOGGED_OUT
}

const SESSION_TIMEOUT = 3600000;



// WEBPACK FOOTER //
// /home/codevi/Documents/PROJET/resa-parklife/front/src/app/service/authentication.service.ts